@if (!this.isBusy) {
    <div>
        <div class="row">
            <div class="m-3">
                <button
                    class="btn btn-sm btn-danger"
                    kendoTooltip
                    title="{{ 'Generate Pdf' | translate }}"
                    (click)="generatePdf()">
                    <fa-icon [icon]="['fas', 'file-pdf']"></fa-icon>
                </button>
            </div>
            <div class="col-sm-1 read_only_field">
                <label>{{ 'Type Code' | translate }}</label>
                @if (model.pcsDocumentAndApprovalType) {
                    <span>{{ model.pcsDocumentAndApprovalType.localizedCode }}</span>
                }
            </div>
            <div class="col-sm-1 read_only_field">
                <label>{{ 'Status Code' | translate }}</label>
                @if (model.pcsDocumentAndApprovalStatus) {
                    <span>
                        {{
                            model.pcsDocumentAndApprovalStatus.localizedCode +
                                ' - ' +
                                model.pcsDocumentAndApprovalStatus.name
                        }}
                    </span>
                }
            </div>
            @if (model.vesselVisitId) {
                <div class="col-sm-1 read_only_field">
                    <label>{{ 'Vessel Visit' | translate }}</label>
                    <span>
                        <a href="vessel-visit/visit/edit/{{ model.vesselVisitId }}">{{ model.vesselVisitNumber }}</a>
                    </span>
                </div>
            }
            @if (model.vesselManoueverId) {
                <div class="col-sm-1 read_only_field">
                    <label>{{ 'Vessel Manouever' | translate }}</label>
                    <span>{{ model.vesselManoueverId }}</span>
                </div>
            }
            @if (model.createdDate) {
                <div class="col-sm-2 read_only_field">
                    <label>{{ 'Created' | translate }}</label>
                    <span>
                        {{ model.createdDate | date: 'dd.MM.yyyy HH:mm' }}
                        @if (model.createdBy) {
                            <i>by {{ model.createdBy.firstName + ' ' + model.createdBy.lastName }}</i>
                        }
                    </span>
                </div>
            }
            @if (model.lastModifiedDate) {
                <div class="col-sm-2 read_only_field">
                    <label>{{ 'Last Modified' | translate }}</label>
                    <span>
                        {{ model.lastModifiedDate | date: 'dd.MM.yyyy HH:mm' }}
                        @if (model.lastModifiedBy) {
                            <i>by {{ model.lastModifiedBy.firstName + ' ' + model.lastModifiedBy.lastName }}</i>
                        }
                    </span>
                </div>
            }
        </div>
        <div class="row">
            <div class="col-12 p-0">
                <kendo-tabstrip>
                    <kendo-tabstrip-tab title="{{ 'Actions / Status Changes' | translate }}" [selected]="true">
                        <ng-template kendoTabContent>
                            <app-pcs-approval-tab-actions-status-changes
                                [actionStatusChanges]="model.actionStatusChanges"
                                [isForApproval]="true"
                                [approvalOrDocumentId]="model.id"
                                [allowedStatus]="model.allowedStatus"
                                [generalActStatusId]="generalActStatusId"
                                [showApproveButtons]="showApproveButtons"
                                [approvalLocation]="approvalLocation"
                                [serviceRequestVersion]="model.serviceRequestVersion"
                                [multipleDeliveryOrderApprovals]="model.multipleDeliveryOrderApprovals"
                                (changesToPcsDocumentOrApproval)="
                                    updatePcsApproval($event)
                                "></app-pcs-approval-tab-actions-status-changes>
                        </ng-template>
                    </kendo-tabstrip-tab>
                    <kendo-tabstrip-tab title="{{ 'Notifications' | translate }}">
                        <ng-template kendoTabContent>
                            <app-pcs-approval-tab-notifications
                                [notifications]="model.notifications"></app-pcs-approval-tab-notifications>
                        </ng-template>
                    </kendo-tabstrip-tab>
                    <kendo-tabstrip-tab title="{{ 'Remarks' | translate }}">
                        <ng-template kendoTabContent>
                            <app-pcs-approval-tab-remarks
                                [remarks]="model.remarks"
                                [isForApproval]="true"
                                [pcsDocumentOrApprovalId]="approvalId"
                                [currentDocumentStatus]="model.pcsDocumentAndApprovalStatus"
                                [allowedInsertRemark]="model.allowedInsertRemark"
                                [allowedRemark]="model.allowedRemark"
                                [isOnlyWatcher]="model.isOnlyWatcher"
                                (newRemarkResponse)="updatePcsApproval($event)"></app-pcs-approval-tab-remarks>
                        </ng-template>
                    </kendo-tabstrip-tab>
                    <kendo-tabstrip-tab title="{{ 'Attachments' | translate }}">
                        <ng-template kendoTabContent>
                            <app-pcs-approval-tab-attachments
                                [attachments]="model.attachments"
                                [isForApproval]="true"
                                [pcsDocumentOrApprovalId]="approvalId"
                                [currentDocumentStatus]="model.pcsDocumentAndApprovalStatus"
                                [allowAttachmentConditions]="model.allowAttachmentConditions"
                                [allowAttachment]="model.allowedAttachment"
                                [isOnlyWatcher]="model.isOnlyWatcher"
                                [createdByOrganizationId]="model.createdByOrganizationId"
                                [actionStatusChanges]="model.actionStatusChanges"
                                (newAttachmentResponse)="updatePcsApproval($event)"></app-pcs-approval-tab-attachments>
                        </ng-template>
                    </kendo-tabstrip-tab>
                    <kendo-tabstrip-tab title="{{ 'Additional Data' | translate }}">
                        <ng-template kendoTabContent>
                            <app-pcs-approval-tab-additional-data
                                [additionalData]="model.additionalData"
                                [isForApproval]="true"
                                [allowedAdditionalData]="
                                    model.allowedAdditionalData
                                "></app-pcs-approval-tab-additional-data>
                        </ng-template>
                    </kendo-tabstrip-tab>
                </kendo-tabstrip>
            </div>
        </div>
    </div>
}

<div style="position: absolute; left: -10000px; top: 0; height: 500px; overflow: hidden">
    @if (printed) {
        <kendo-pdf-export
            #pdf
            forcePageBreak=".page-break"
            paperSize="A4"
            margin="0.8cm"
            [landscape]="true"
            [autoPrint]="false">
            <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                <div class="pageNum">
                    {{ 'Page' | translate }} {{ pageNum }} {{ 'of' | translate }} {{ totalPages }}
                </div>
            </ng-template>
            <app-pcs-approval-print
                [model]="printModel"
                [now]="now"
                (logoLoaded)="onLogoLoaded()"></app-pcs-approval-print>
        </kendo-pdf-export>
    }
</div>
